import React from 'react';
import { useTranslation } from 'react-i18next';

const LabPage = ({ onButtonClick, onBack, onOpenMicroscopy, onOpenMicroscopyUro, onOpenClinical, onOpenBlood, onOpenBiochemistry, onOpenCoagulation, onOpenSerology, onOpenExpress, onOpenCytology }) => {
  const { t } = useTranslation();
  
  const labServices = [
    { icon: 'microscopy.png', name: t('labPage.services.microscopy'), price: '' },
    { icon: 'uroscopy.png', name: t('labPage.services.microscopyUro'), price: '' },
    { icon: 'urine.png', name: t('labPage.services.clinical'), price: '' },
    { icon: 'blood-test.png', name: t('labPage.services.blood'), price: '' },
    { icon: 'biochemistry.png', name: t('labPage.services.biochemistry'), price: '' },
    { icon: 'coagulation.png', name: t('labPage.services.coagulation'), price: '' },
    { icon: 'serology.png', name: t('labPage.services.serology'), price: '' },
    { icon: 'express-test.png', name: t('labPage.services.express'), price: '' },
    { icon: 'cytology.png', name: t('labPage.services.cytology'), price: '' },
    { icon: 'back.png', name: t('labPage.services.back'), price: '' }
  ];

  const handleServiceClick = (serviceName) => {
    if (serviceName === t('labPage.services.back')) {
      onBack();
    } else if (serviceName === t('labPage.services.microscopy')) {
      onOpenMicroscopy();
    } else if (serviceName === t('labPage.services.microscopyUro')) {
      onOpenMicroscopyUro();
    } else if (serviceName === t('labPage.services.clinical')) {
      onOpenClinical();
    } else if (serviceName === t('labPage.services.blood')) {
      onOpenBlood();
    } else if (serviceName === t('labPage.services.biochemistry')) {
      onOpenBiochemistry();
    } else if (serviceName === t('labPage.services.coagulation')) {
      onOpenCoagulation();
    } else if (serviceName === t('labPage.services.serology')) {
      onOpenSerology();
    } else if (serviceName === t('labPage.services.express')) {
      onOpenExpress();
    } else if (serviceName === t('labPage.services.cytology')) {
      onOpenCytology();
    } else {
      onButtonClick(serviceName);
    }
  };

  return (
    <>
      <header className="header">
        <div className="clinic-logo">
          <div className="logo-icon">
            <img src="/icons/lab.png" alt={t('labPage.title')} width="40" height="40" />
          </div>
          <h1>{t('labPage.title')}</h1>
        </div>
        
        <div className="user-greeting">
          <p>{t('labPage.subtitle')}</p>
        </div>
      </header>

      <main className="main-content">
        <div className="welcome-section">
          <h2>{t('labPage.welcome')}</h2>
          <p className="subtitle">{t('labPage.chooseService')}</p>
        </div>

        <div className="buttons-grid">
          {labServices.map((service, index) => (
            <button 
              key={index}
              className={`service-btn ${service.name === t('labPage.services.back') ? 'back-btn' : ''}`}
              onClick={() => handleServiceClick(service.name)}
            >
              <span className="btn-icon">
                <img 
                  src={`/icons/${service.icon}`} 
                  alt={service.name} 
                  width="30" 
                  height="30" 
                />
              </span>
              <div className="service-info">
                <span className="service-name">{service.name}</span>
              </div>
            </button>
          ))}
        </div>
      </main>

      <footer className="footer">
        <p>{t('labPage.footer.main')}</p>
        <p className="footer-info">{t('labPage.footer.info')}</p>
      </footer>
    </>
  );
};

export default LabPage;